<template>
  <div
    class="container container-xl margin-xl-bottom margin-xl-top l:margin-2xl-top">
    <page-title-block
      :text="
        linkCollection ? linkCollection.title : t('ag.linkCollection.defaultDisplayTitle')
      "
      :auto-translate="false"
      theme="lead-1"></page-title-block>
    <div v-if="linkCollection" class="links margin-xl-top l:margin-2xl-top">
      <p class="margin-xl-bottom" v-if="isNonEmptyString(linkCollection.description)">
        {{linkCollection.description}}
      </p>
      <collapsable-field-set v-for="group of linkCollection.linkGroups" :title="group.title + ` (${group?.links?.length || 0})`" auto-translate="false"
      :initially-opened="false">
        <div class="padding-s bg-bg-2 border-thin-gray-1 border-radius-s margin-l-bottom" v-for="link in group.links">
          <h4 class="margin-m-bottom">{{link.title}} - <a :href="sanitizeLink(link.link)" target="_blank">
            {{t('ag.linkCollection.clickHere')}}
          </a></h4>
          <p v-if="isNonEmptyString(link.description)">{{link.description}}</p>
        </div>
      </collapsable-field-set>
    </div>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import { useStore } from "vuex";
import PageTitleBlock from "@/client/applications/agaloola/components/base/frameworks/we/AgPageTitleBlock";
import TermMain from "@/client/applications/agaloola/components/items/term/Main";
import CollapsableFieldSet from "@/client/components/base/frameworks/we/form/CollapsableFieldSet.vue";

export default {
  components: {
    CollapsableFieldSet,
    PageTitleBlock,
    TermMain,
  },
  layout: "default",
  props: {
    alias: {
      type: [String],
      default: false,
    },
  },
  setup(props) {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(
      props,
      useStore()
    );
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "ag.linkCollection.defaultPageTitle",
  data: function () {
    return {
      linkCollection: false,
      asyncData: {
        linkCollection: {
          target: `entity/linkCollection/${this.alias}`,
          data: {
            lookupField: "alias",
            identifier: this.alias,
          },
          options: {
            dataMutator(data) {
              console.log("mutator", data);
              return data;
            },
            errorHandler: 404,
          },
        },
      },
    };
  },
  watch: {},
  methods: {
    isNonEmptyString(candidate) {
      return utilities.isNonEmptyString(candidate);
    }
  }
};
</script>

<style scoped lang="scss">
.terms {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
  grid-gap: var(--margin-xl);

  @media (max-width: 1024px) {
    max-width: 400px;
    margin-inline: auto;
    grid-template-columns: minmax(0, 1fr);
  }
}

.term {
  max-width: 100%;
}
</style>
